<template>
  <el-dialog v-if="showoff" :visible.sync="showoff" title="选择合作模式" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <!-- 顶部选择按钮 -->
    <div class="mode-selector">
      <div class="mode-button" :class="{ 'selected': selectedModes.includes('1') }" @click="toggleMode('1')">
        <i class="el-icon-shop"></i>
        <span>平台开店</span>
        <i v-if="selectedModes.includes('1')" class="el-icon-check check-icon"></i>
      </div>
      <div class="mode-button" :class="{ 'selected': selectedModes.includes('2') }" @click="toggleMode('2')">
        <i class="el-icon-connection"></i>
        <span>入驻供应链</span>
        <i v-if="selectedModes.includes('2')" class="el-icon-check check-icon"></i>
      </div>
    </div>

    <!-- 展示区域 -->
    <div class="display-area">
      <!-- 平台开店展示 -->
      <div class="process-display">
        <div class="process-title">平台开店</div>
        <div class="process-label">流程说明:</div>
        <div class="process-image">
          <img src="https://wsnbh-img.hzanchu.com/default/589823865222127616.png" alt="平台开店流程图" />
        </div>
        <div class="agreement-link">
          <el-link type="primary">（平台开店协议）</el-link>
        </div>
      </div>

      <!-- 供应链合作展示 -->
      <div class="process-display">
        <div class="process-title">入驻供应链</div>
        <div class="process-label">流程说明:</div>
        <div class="process-image">
          <img src="https://wsnbh-img.hzanchu.com/default/589823557188247552.png" alt="供应链合作流程图" />
        </div>
        <div class="agreement-link">
          <el-link type="primary">（供应链合作协议）</el-link>
        </div>
      </div>
    </div>

    <div class="btn-box">
      <el-button type="primary" @click="submitClick">确定</el-button>
      <el-button type="default" @click="cancelClick">跳过</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {sleep} from '@/com.js';

export default {
  data() {
    return {
      showoff: false,
      selectedModes: ['1', '2'], // 默认两个都选中
      userInfo: null
    };
  },
  methods: {
    show(userInfo) {
      this.userInfo = userInfo;
      this.showoff = true;
    },
    toggleMode(mode) {
      const index = this.selectedModes.indexOf(mode);
      if (index > -1) {
        // 如果已选中，则取消选中
        this.selectedModes.splice(index, 1);
      } else {
        // 如果未选中，则选中
        this.selectedModes.push(mode);
      }
    },
    cancelClick() {
      this.showoff = false;
      this.$router.replace({path: '/'});
    },
    submitClick() {
      if (!this.selectedModes.length) {
        this.$message.error('请选择销售模式');
        return;
      }

      if (this.selectedModes.includes('1')) {
        this.$router.push({
          path: '/store',
          query: {
            id: this.userInfo.suppliersId,
            type: 'add',
            tipVisible: 0,
            stepsVisible: 0,
            model: this.selectedModes
          }
        });
        return;
      }

      if (this.selectedModes.includes('2')) {
        this.$router.push({
          path: '/supplyChain/cooperation/detail',
          query: {
            type: 'add',
            suppliersId: this.userInfo.suppliersId
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 顶部选择按钮区域
.mode-selector {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  justify-content: center;
}

.mode-button {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fff;
  position: relative;
  min-width: 120px;
  justify-content: center;

  i {
    margin-right: 8px;
    font-size: 16px;
    color: #909399;
  }

  span {
    font-size: 14px;
    color: #909399;
  }

  &:hover {
    border-color: #409eff;
  }

  &.selected {
    border-color: #f56c6c;
    
    i:not(.check-icon) {
      color: #f56c6c;
    }
    
    span {
      color: #f56c6c;
    }
  }

  .check-icon {
    position: absolute;
    top: -5px;
    right: -5px;
    color: #f56c6c;
    font-size: 16px;
    font-weight: bold;
    margin: 0;
  }
}

// 展示区域
.display-area {
  margin-bottom: 30px;
}

.process-display {
  .process-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 15px;
    // text-align: center;
  }

  .process-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 15px;
  }

  .process-image {
    margin-bottom: 15px;
    
    img {
      width: 100%;
      height: auto;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  .agreement-link {
    text-align: center;
  }
}

.btn-box {
  text-align: center;
  
  .el-button {
    margin: 0 10px;
    padding: 12px 30px;
  }
  
  .el-button--primary {
    background-color: #f56c6c;
    border-color: #f56c6c;
    
    &:hover {
      background-color: #f78989;
      border-color: #f78989;
    }
  }
}

// 弹窗样式调整
::v-deep(.el-dialog) {
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.2);
}

::v-deep(.el-dialog__header) {
  background: #FFFFFF;
  border-radius: 8px 8px 0 0;
  padding: 20px;
  
  .el-dialog__title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
}

::v-deep(.el-dialog__body) {
  padding: 30px;
  background: #FFFFFF;
}
</style>